import jack from 'jack-logs';
import uuid from 'uuid';

const SECOND = 1000; // 1s = 1000ms
const MINUTE = 60 * SECOND; // 60 * 1000 milliseconds
const HOUR = 60 * MINUTE;
const allowedTypes = ['short', 'long'];
let instance = null;
const globalBackgroundProcess = { uuid: null };
window.backgroundProcess = globalBackgroundProcess; // share this between instances of app

export default class Background {
  constructor(store, shortPoll, longPoll) {
    if (window.backgroundProcess.uuid) {
      const e = new Error();
      jack.warn({
        message: 'Duplicate background worker attempted to start',
        details: globalBackgroundProcess,
        stack: e.stack,
      });
    }
    if (instance) {
      return instance;
    }
    this.store = store;
    this.isStarted = false;
    this.shortPollRefreshers = [];
    this.longPollRefreshers = [];
    this.storeRefreshers('short', shortPoll);
    this.storeRefreshers('long', longPoll);
    this.attachListeners();
    this.uuid = uuid();
    instance = this;
    globalBackgroundProcess.uuid = this.uuid;
    return this;
  }

  storeRefreshers(type, fns) {
    if (!fns) {
      // these aren't set
      return null;
    }
    if (!allowedTypes.includes(type)) {
      throw new Error(`Refresher Type ${type} is not in the allowed list of ${allowedTypes}`);
    }
    const refreshers = fns instanceof Array ? fns : [fns];
    refreshers.forEach((refresher) => {
      if (!(refresher instanceof Function)) {
        throw new Error('Refreshers must be functions');
      }
    });

    return this[`${type}PollRefreshers`].push(...refreshers);
  }

  async refresh(fns) {
    const state = this.store.getState();
    if (state.getIn(['account', 'accessToken'])) {
      return Promise.all(fns.map(async fn => this.store.dispatch(fn())));
    }
    return Promise.resolve();
  }

  async refreshNow() {
    return Promise.all([
      this.refresh(this.shortPollRefreshers),
      this.refresh(this.longPollRefreshers),
    ]);
  }

  timeoutSetter(fns, timeout) {
    return setInterval(() => this.refresh(fns), timeout);
  }

  shortPoll() {
    this.shortPollInterval = this.timeoutSetter(this.shortPollRefreshers, 5 * MINUTE);
  }

  longPoll() {
    this.longPollInterval = this.timeoutSetter(this.longPollRefreshers, 1 * HOUR);
  }

  startPoll() {
    this.isStarted = true;
    this.shortPoll();
    this.longPoll();
  }

  stopPoll() {
    this.isStarted = false;
    clearInterval(this.shortPollInterval);
    clearInterval(this.longPollInterval);
  }

  restartPoll() {
    this.stopPoll();
    this.startPoll();
  }

  attachListeners() {
    if (window.cordova) {
      document.addEventListener('resume', () => this.refreshNow());
    }
  }
}



// WEBPACK FOOTER //
// ./src/workers/Background/index.js